import { fetchEndpoint } from "../network";

/**
 * 内容管理 - 文章管理
 */

export default {
  //锁定
  lock(params) {
    return fetchEndpoint(
      "/create-platform/content/article/lock",
      "GET",
      params
    );
  },
  // 列表
  list(params) {
    return fetchEndpoint("/create-platform/content/article", "GET", params);
  },

  // 新建文章
  create(params) {
    return fetchEndpoint("/create-platform/content/article", "POST", params);
  },

  // 文章详情
  detail(params) {
    return fetchEndpoint(
      "/create-platform/content/article/detail",
      "GET",
      params
    );
  },
  //文章内容转换为音频
  toAudio(params) {
    return fetchEndpoint(
      "/create-platform/content/article/audio",
      "POST",
      params
    );
  },

  // 编辑文章
  modify(params) {
    return fetchEndpoint(
      "/create-platform/content/article/modify",
      "POST",
      params
    );
  },

  // 提交审核
  examine(params) {
    return fetchEndpoint(
      "/create-platform/content/article/examine",
      "POST",
      params
    );
  },

  // 撤销审核
  revertExamine(params) {
    return fetchEndpoint(
      "/create-platform/content/article/revert",
      "POST",
      params
    );
  },

  // 发布
  publish(params) {
    return fetchEndpoint(
      "/create-platform/content/article/publish",
      "POST",
      params
    );
  },

  // 显示
  show(params) {
    return fetchEndpoint(
      "/create-platform/content/article/show",
      "POST",
      params
    );
  },

  // 隐藏
  hide(params) {
    return fetchEndpoint(
      "/create-platform/content/article/hidden",
      "POST",
      params
    );
  },

  // 撤稿
  revert(params) {
    return fetchEndpoint(
      "/create-platform/content/article/revert",
      "POST",
      params
    );
  },
  //删除判断 与管理后台的接口不同
  beforeRemove(params) {
    return fetchEndpoint(
      "/create-platform/qa/contentOperationInfo",
      "GET",
      params
    );
  },

  // 删除
  remove(params) {
    return fetchEndpoint(
      "/create-platform/content/article/delete",
      "POST",
      params
    );
  },

  // 媒体号列表
  mediaList(params) {
    return fetchEndpoint("/create-platform/user/list", "GET", params);
  },

  // 评论列表
  commentList(params) {
    return fetchEndpoint(
      "/create-platform/comment/template/list",
      "GET",
      params
    );
  },

  // 文章/视频-查看评论的评论列表
  commentViewList(parmas) {
    return fetchEndpoint("/create-platform/comment/comments", "GET", parmas);
  },
};
